import { api } from "@/api/client";
import type {
  ReviewQueueItem,
  ReviewQueueResponse,
  ReviewsDashboardResponse,
} from "@/types/api";

export interface QueueFilters {
  platform?: string;
  legal_name?: string;
  rating?: number;
  post_status?: string;
  brand?: string;
  date_from?: string;
  date_to?: string;
  sort?: string;
  q?: string;
  limit?: number;
  offset?: number;
}

export interface EditResult {
  item: ReviewQueueItem;
  issues: string[];
}

export interface BulkPublishResult {
  published: number;
  skipped: { id: string; issues: string[] }[];
}

export interface BulkCancelResult {
  cancelled: number;
}

export interface BulkRegenerateResult {
  regenerated: number;
}

export async function listQueue(filters: QueueFilters): Promise<ReviewQueueResponse> {
  const params: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== "" && v !== null) params[k] = v;
  }
  const { data } = await api.get<ReviewQueueResponse>("/reviews", { params });
  return data;
}

export async function editReply(
  id: string,
  text: string,
  note?: string | null,
): Promise<EditResult> {
  const { data } = await api.post<EditResult>(`/reviews/${id}/edit`, { text, note });
  return data;
}

export async function publishReply(id: string): Promise<ReviewQueueItem> {
  const { data } = await api.post<ReviewQueueItem>(`/reviews/${id}/publish`);
  return data;
}

export async function rejectReply(id: string): Promise<ReviewQueueItem> {
  const { data } = await api.post<ReviewQueueItem>(`/reviews/${id}/reject`);
  return data;
}

export async function bulkPublish(ids: string[]): Promise<BulkPublishResult> {
  const { data } = await api.post<BulkPublishResult>("/reviews/bulk-publish", { ids });
  return data;
}

export async function bulkCancel(ids: string[]): Promise<BulkCancelResult> {
  const { data } = await api.post<BulkCancelResult>("/reviews/bulk-cancel", { ids });
  return data;
}

export async function regenerateReply(replyId: string): Promise<ReviewQueueItem> {
  const { data } = await api.post<ReviewQueueItem>(`/reviews/${replyId}/regenerate`);
  return data;
}

export async function bulkRegenerate(ids: string[]): Promise<BulkRegenerateResult> {
  const { data } = await api.post<BulkRegenerateResult>("/reviews/bulk-regenerate", { ids });
  return data;
}

export async function getReviewsDashboard(): Promise<ReviewsDashboardResponse> {
  const { data } = await api.get<ReviewsDashboardResponse>("/reviews/dashboard");
  return data;
}
